/**
 * Phase 4g.E (Feb 2026) — QR-Vorschau-Modal extrahiert aus
 * `WorkshopOrdersPage.jsx`. Lädt einen QR-Code-PNG vom Backend
 * (`/workshop-orders/{id}/qr-png`), zeigt ihn an und erlaubt Download.
 */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, X } from "lucide-react";

import api from "../../lib/api";
import { Button } from "../ui/button";
import QzPrintControls from "../qz/QzPrintControls";

function QrPreviewModal({ order, onClose, onDownload }) {
    // QR-Bild direkt vom Backend laden (mit Auth via api.defaults.headers)
    const [imgUrl, setImgUrl] = useState("");
    useEffect(() => {
        let revoke = null;
        api.get(`/work-orders/${order.id}/qr-code.png`, { responseType: "blob" })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data], { type: "image/png" }));
                revoke = url;
                setImgUrl(url);
            })
            .catch(() => toast.error("QR-Code konnte nicht geladen werden"));
        return () => { if (revoke) window.URL.revokeObjectURL(revoke); };
    }, [order.id]);

    return (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-testid="qr-preview-modal">
            <div className="bg-white max-w-md w-full rounded-sm shadow-xl" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
                    <div>
                        <div className="font-display font-black text-lg">QR-Code · {order.order_number}</div>
                        <div className="text-[11px] text-gray-500">Scannen öffnet den Auftrag im Dealer-Frontend</div>
                    </div>
                    <button onClick={onClose} className="p-1 rounded-sm hover:bg-gray-100" data-testid="qr-close">
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="p-6 flex flex-col items-center gap-4">
                    {imgUrl ? (
                        <img src={imgUrl} alt="QR-Code" className="w-64 h-64 border border-gray-200" data-testid="qr-image" />
                    ) : (
                        <div className="w-64 h-64 bg-gray-100 flex items-center justify-center text-gray-400">Lade…</div>
                    )}
                    <div className="text-xs text-gray-600 text-center">
                        Diesen QR-Code an Schlüssel-Anhänger, Fahrzeug oder Auftragsmappe kleben.
                        Werkstatt-Mitarbeiter scannen mit Smartphone und öffnen den Auftrag sofort.
                    </div>
                    <QzPrintControls pdfPath={`/work-orders/${order.id}/qr-sticker.pdf`} testid="qr-qz" />
                </div>
                <div className="px-5 py-3 border-t border-gray-200 flex justify-end gap-2">
                    <Button onClick={onClose} variant="outline" className="rounded-sm" data-testid="qr-close-btn">
                        Schließen
                    </Button>
                    <Button onClick={onDownload} className="bg-[#111827] hover:bg-black text-white rounded-sm uppercase tracking-wider" data-testid="qr-download-pdf">
                        <Download className="w-3 h-3 mr-1.5" /> Aufkleber-PDF
                    </Button>
                </div>
            </div>
        </div>
    );
}




export default QrPreviewModal;
